//constantes pour activer/désactiver des fonctionnalités
export const FEATURE = {
  ENABLE_LANDSCAPE_MODE: true,
  ENABLE_LR_LIST: true,
  ENABLE_LR_PH_FILTERS: true,
  ENABLE_LIGHT_COMMUNICATION: true,
  ENABLE_OUT_DATED_DATA: true,
  ENABLE_BACK_TO_TOP: false, //Ne pas réactiver tant que les optimisations sur le composant back_to_top n'ont pas été réalisées
};
